import React from 'react';
import { styled } from 'dripsy';
import { View, ViewProps } from 'react-native';
import { useTranslation } from 'react-i18next';
import {
  NavigationHelpers,
  ParamListBase,
  useNavigation,
} from '@react-navigation/native';

import { unCapitalize } from '@utils';
import { BaseText } from '../common/BaseText';
import { Touchable } from '../common/Touchable';
import { ScreensNameType } from '@navigation';

const Container = styled(View)({
  flexDirection: 'row',
});

interface ITextStyleProps {
  active?: boolean;
}

const Text = styled(BaseText)((props: ITextStyleProps) => ({
  variant: 'text.xsmall',
  color: props.active ? '$heading800' : '$text400',
}));

export interface IBreadcrumbBarProps extends ViewProps {
  routes: ScreensNameType[];
}

type NavigationPropType = NavigationHelpers<ParamListBase>;

/**
 * This is Web only component
 * For mobile we do not have breadcrumbs
 * For each screen object must have title in JSON
 */
export function BreadcrumbBar({
  routes,
  ...props
}: IBreadcrumbBarProps) {
  const { t } = useTranslation();
  const nav = useNavigation<NavigationPropType>();

  function onPress(active: boolean, screen: ScreensNameType) {
    return () => {
      if (!active) {
        // FIXME: Fix types
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        nav.navigate(screen);
      }
    };
  }

  return (
    <Container {...props}>
      {routes.map((screen: ScreensNameType, index: number) => {
        const active = routes.length - 1 === index;
        return (
          <Touchable key={index} onPress={onPress(active, screen)}>
            <Text active={active}>
              {
                // We need to convert first letter to lower case for each screen name
                // to get right Translation key
                t(`${unCapitalize(screen)}.title`)
              }{' '}
              {active ? '' : ' / '}
            </Text>
          </Touchable>
        );
      })}
    </Container>
  );
}
